var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative w-full rounded h-600-px",attrs:{"id":"map-canvas","data-lat":"40.748817","data-lng":"-73.985428"}})}
var staticRenderFns = []

export { render, staticRenderFns }